<template>
  <div>
    <div class="empty_wrap">
      <div class="img_box"></div>
      <div class="text_box">{{$t('no_point')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointEmptyDefaultLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>